export default "/images/settings.png?b6ab4080cdbb79eff9156eb879d182d8";